<template>
    <div>
        <header-signature v-if="salesPitchDto.title" :text="salesPitchDto.title" class="pb-1" />

        <div class="bg-gray2 p-1 ps-lg-2 pe-lg-2">
            <div class="accordion">
                <div v-for="(pitch, index) in salesPitchDto.pitches" :key="index">
                    <div class="card multi">
                        <div class="card-header">
                            <button
                                class="collapsed"
                                data-bs-toggle="collapse"
                                :data-bs-target="'#pitch-collapse-'+ index"
                                :aria-controls="'#' + 'pitch-collapse-'+ index"
                                aria-expanded="false"
                            >
                                <span class="d-flex align-items-center accordion-card-title">
                                    <span class="item-icon" :class="pitch.iconName" aria-hidden="true" />
                                    <span class="accordion-title" v-html="pitch.title" />
                                    <span class="accordion-icon" aria-hidden="true" />
                                </span>
                            </button>
                        </div>
                        <div
                            :id="'pitch-collapse-'+ index"
                            class="collapse"
                            :aria-labelledby="'pitch-'+ index"
                        >
                            <div class="accordion-card-body standard">
                                <p class="mb-0 py-0" v-html="pitch.descriptionHtml" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import HeaderSignature from "../../common/components/vue/HeaderSignature.vue";

export default {
    components: {HeaderSignature},
    props: {
        salesPitchDto: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>

.pitch-icon {
    font-size: 29px;
    margin-right: 5px;
}

</style>
